// body-scroll-lock's own test for the devices it blocks touches on.
const IOS = typeof navigator !== 'undefined' && (/iP(ad|hone|od)/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
function stop(e) {
  e.stopPropagation();
}
function scrolls(element) {
  const {
    overflowX,
    overflowY
  } = getComputedStyle(element);
  return /auto|scroll/.test(overflowY) && element.scrollHeight > element.clientHeight || /auto|scroll/.test(overflowX) && element.scrollWidth > element.clientWidth;
}

/**
 * Lets a finger scroll what scrolls inside a modal on an iPhone/iPad: the
 * forum rules' text before signing up, a zoomed photo of a post, a species'
 * or a painting's gallery, a list of search results… (2026-10).
 *
 * Core's ModalManager locks the page behind an open modal with
 * body-scroll-lock, which on iOS cancels any touchmove inside the modal
 * that the modal's own box can't scroll by - its listeners are on that
 * box and on the document. So the rules' text never scrolled, nor a zoomed
 * photo up or down (left and right did: only a vertical move is
 * checked).
 *
 * A touchmove inside such a box stops there instead, before those
 * listeners: the box scrolls, natively. Set on the way down (capture, on
 * the document), for that one event - any handler of the modal's own
 * content still gets it first.
 */
export default function allowTouchScrollInModals() {
  if (!IOS) return;
  document.addEventListener('touchmove', e => {
    const target = e.target instanceof Element ? e.target : null;
    const modal = target?.closest('.ModalManager');
    for (let element = target; element && modal && element !== modal; element = element.parentElement) {
      if (scrolls(element)) {
        element.addEventListener('touchmove', stop, {
          once: true,
          passive: true
        });
        return;
      }
    }
  }, {
    capture: true,
    passive: true
  });
}